import React from 'react';
import StButton from '../misc/button';

import { withFirebase } from '../Firebase';

const SignOutButton = ({ firebase }) => (
    <StButton onClick={firebase.doSignOut} text="Sign Out" />
);

export default withFirebase(SignOutButton);